@if(link) {
  <a [routerLink]="link">
    <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
  </a>
} @else {
  <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
}

<ng-template #cardTemplate>
  <div class="group/info-card rounded-2xl w-full min-h-[300px] relative isolate overflow-hidden bg-surface-0 dark:bg-surface-900" [ngClass]="{
  'w-full': stretched,
  'h-full': stretched,
  'py-4 px-6': !splitBackground
}">
    @if (backgroundImgSrc && !splitBackground) {
      <img class="absolute top-0 left-0 -z-1 w-full h-full object-cover"
           [src]="backgroundImgSrc"/>
    }
    <div class="flex flex-col min-h-[inherit] h-[inherit]"
         [ngClass]="{'text-white drop-shadow': backgroundImgSrc && !splitBackground}">
      <div class="grid flex-1 relative" [ngClass]="{'text-white': backgroundImgSrc, 'p-4': splitBackground}">
        @if (backgroundImgSrc && splitBackground) {
          <div class="absolute top-0 left-0 -z-1 w-full h-full overflow-hidden">
            <img class="absolute scale-110 top-0 left-0 -z-1 w-full h-full object-cover"
                 [src]="backgroundImgSrc"/>
          </div>
        }

        <div class="h-full">
          @if (headerLeftTemplate || headerRightTemplate) {
            <div class="flex flex-row">
              <div [ngClass]="{'w-1/2': headerRightTemplate, 'w-full': !headerRightTemplate}">
                @if (headerLeftTemplate) {
                  <ng-container *ngTemplateOutlet="headerLeftTemplate"></ng-container>
                }
              </div>
              @if (headerRightTemplate) {
                <div class="w-1/2 text-right">
                  <ng-container *ngTemplateOutlet="headerRightTemplate"></ng-container>
                </div>
              }
            </div>
          }

          <div class="w-full text-3xl uppercase">
            {{ headline1 }}
          </div>
          <div class="h-full grid place-content-center">
            <ng-container *ngTemplateOutlet="centerTemplate"></ng-container>
          </div>
        </div>
      </div>

      <div [ngClass]="{
      'py-4 px-6': splitBackground
    }">
        @if (headline3) {
          <div class="uppercase opacity-70">
            {{ headline3 }}
          </div>
        }
        @if (headline2) {
          <div class="text-2xl">
            {{ headline2 }}
          </div>
        }
        @if (description) {
          <div class="opacity-70">
            {{ description }}
          </div>
        }

        @if (footerLeftTemplate || footerRightTemplate) {
          <div class="flex flex-row">
            <div [ngClass]="{'w-1/2': footerRightTemplate, 'w-full': !footerRightTemplate}">
              @if (footerLeftTemplate) {
                <ng-container *ngTemplateOutlet="footerLeftTemplate"></ng-container>
              }
            </div>
            @if (footerRightTemplate) {
              <div class="w-1/2 text-right">
                <ng-container *ngTemplateOutlet="footerRightTemplate"></ng-container>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>
